import React, { useState, useEffect, useRef } from 'react';
import './QuizIntro.css';

const QuizIntro = props => {
	const mounted = useRef(false);
	const [quizDifficulty, setQuizDifficulty] = useState(2);    // setting default to 'normal' difficulty
	const [quizLevel, setQuizLevel] = useState('Normal');    // setting default to 'normal' difficulty
	const [quizDuration, setQuizDuration] = useState(30);

	useEffect(() => {
		if (!mounted.current) {
			mounted.current = true;
		} else {
			let duration = null, level = null;
			if (quizDifficulty === 1) {
				duration = 40;
				level = 'Slow';
			}
			if (quizDifficulty === 2) {
				duration = 30;
				level = 'Normal';
			}
			if (quizDifficulty === 3) {
				duration = 20;
				level = 'Fast'
			}
			setQuizLevel(level);
			setQuizDuration(duration);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [quizDifficulty]);

	return (
		<div className='quizBlockIntro-container'>
			<p>Please select Quiz Difficulty</p>
			<div className='quizBlockIntro-confirmation'>
				<div>
					<input type="range" min="1" max="3" step="1"
				       id='quiz-difficulty-slider' name='quiz-difficulty-slider'
				       value={quizDifficulty}
					   onChange={ change => setQuizDifficulty(parseInt(change.target.value)) }
					/>
				</div>
				<div>
					<label htmlFor='quiz-difficulty-slider'>
						Quiz Speed: {quizLevel}
						<br/>
						Quiz Duration: {quizDuration} minutes
					</label>
				</div>
			</div>
			<div className='quizBlockIntro-ready-btn' onClick={() => props.readyBtnClicked(quizDifficulty)}>
				<span className='quizBlockIntro-icon-container'>
					<i className="fa fa-check fa-fw"/>
				</span>
				<span>I'm ready</span>
			</div>
		</div>
	)
};

export default QuizIntro;

